import { Star } from 'lucide-react';
import { classNames } from '@/lib/utils';

/**
 * Valoración de 1 a 5. Sirve de dos maneras: como adorno de una fila y como
 * control de la ficha.
 *
 * Volver a pulsar la estrella que ya estaba marcada quita la valoración: sin
 * eso, una nota puesta sin querer no se puede deshacer.
 */
interface Props {
  valor?: number | null;
  onChange?: (valor: number | null) => void;
  tamano?: number;
  /** Etiqueta a la derecha para lectores de pantalla y ratones. */
  titulo?: string;
}

export default function Estrellas({ valor, onChange, tamano = 16, titulo }: Props) {
  const nota = valor ?? 0;
  const editable = !!onChange;

  const estrellas = [1, 2, 3, 4, 5].map((n) => {
    const marcada = n <= nota;
    const icono = (
      <Star
        size={tamano}
        className={marcada ? 'text-amber-500' : 'text-sereno-dark/20'}
        fill={marcada ? 'currentColor' : 'none'}
      />
    );

    if (!editable) return <span key={n}>{icono}</span>;

    return (
      <button
        key={n}
        type="button"
        onClick={() => onChange(nota === n ? null : n)}
        className="p-0.5 rounded hover:bg-sereno-blue/20 transition-colors"
        aria-label={nota === n ? `Quitar la valoración de ${n}` : `Valorar con ${n}`}
        aria-pressed={marcada}
      >
        {icono}
      </button>
    );
  });

  return (
    <span
      className={classNames('inline-flex items-center', editable && '-ml-0.5')}
      title={titulo || (nota ? `Valoración: ${nota} de 5` : 'Sin valorar')}
    >
      {estrellas}
    </span>
  );
}
